<template>
  <div class="printer">
    <div class="content c895">
      <h2>Dodajte Tiskalnik</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev7" style="display:none;">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a href="javascript:void(0)" class="btn" title="OK" onclick="popupDelete()">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE PODATKE O TISKALNIKU</h3>
        <div class="f-item select">
          <label>
            Tip tiskalnika:
            <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
            <span></span>
          </label>
          <select name id>
            <option value="0">Izberite</option>
            <option value="119">Brizgalni tiskalnik za domačo uporabo</option>
            <option value="120">Laserski tiskalnik za domačo uporabo</option>
            <option value="121">Tiskalnik za pisarne</option>
          </select>
        </div>
      </div>
      <div class="question">
        <p>
          Koliko ur
          <b>na teden</b> uporabljate tiskalnik in kdaj?
        </p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
          <div class="tooltip">
            Na porabo elektrike in višino računa vpliva tarifa, v kateri uporabljate tiskalnik. Manjša tarifa velja med tednom ponoči (od 22.00 do 6.00) ter ob sobotah, nedeljah ter dela prostih dnevih cel dan.
            <p></p>
          </div>
        </div>
      </div>
      <div class="answer-list">
        <ul>
          <li class="first">
            <div>PON-PET, 6:00-22:00</div>
            <div>PON-PET, 22:00-6:00 IN SOB-NED</div>
          </li>
          <li class="answer odd">
            <span class="small">št. ur</span>
            <div>
              <input name type="text" id />
              <span>ur</span>
            </div>
            <div class="last">
              <input name type="text" id />
              <span>ur</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" name value="Dodaj" @click="addedApplianceNum(8)" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O TISKALNIKU</h3>
        <p>Tiskalnik je naprava, ki v stanju v pripravljenosti porabi 10 % električne energije pri celotni uporabi tiskalnika. Kako odkrijemo porabnike energije v stanju pripravljenosti? V temi ugasnimo vse luči in poiščimo, kje gori kakšna lučka ali sveti zaslon. Druga možnost je da poiščemo naprave, ki so tople, čeprav jih trenutno nimamo v uporabi. Tiskalnik sodi v skupino naprav, ki so po navadi v stanju pripravljenosti.</p>

        <div class="average">
          <h4>Povprečna poraba laserskega tiskalnika</h4>
          <span>260 kWh/leto</span>
          <p>
            <strong>19,63 € / leto</strong> (enotarifno)
            <br />
            <strong>16,83 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    addedApplianceNum(x) {
      console.log('From printer');
      this.$emit('applianceFormClicked', x);
    },
  },
};
</script>

<style>
</style>